import { debounceAggregator } from '../../utils/debounceAggregator';
import {
    _getCollectionById,
    _getCollectionByName
} from '~api/CollectionsAPI/handlers/CollectionsHandlers';

const defaultTime = 150;

export const getCollectionByCollectionName = debounceAggregator({
    callback: _getCollectionByName,
    reducer: (acc: string[], collectionName: string) => {
        const firstIndex = acc.includes(collectionName);

        return firstIndex ? acc : [...acc, collectionName];
    },
    time: defaultTime
});

export const getCollectionById = debounceAggregator({
    callback: _getCollectionById,
    reducer: (acc: string[], collectionName: string) => {
        const firstIndex = acc.includes(collectionName);

        return firstIndex ? acc : [...acc, collectionName];
    },
    time: defaultTime
});
